<template>
<span>
    <span class="odr-onetime-tooltip">
        <slot name="trigger"/>
        <div v-if="show && !disabled"
             class="odr-onetime-tooltip__content"
             tabindex="0"
             ref="onetimeTooltipContent"
             @blur="onBlur">
            <div class="odr-onetime-tooltip__body">
                <slot name="content"/>
                <div>
                    <align-opposite>
                        <button type="button"
                                class="odr-onetime-tooltip__body-button"
                                :data-qa="'onetime-tooltip'"
                                :data-qa-recorder="'onetime.tooltip'"
                                @mousedown="submit">
                            <text-regular color="plain" bold="true">
                                {{ $trl('aw.got_it') }}
                            </text-regular>
                        </button>
                    </align-opposite>
                </div>
            </div>
        </div>
    </span>
</span>
</template>
<script>
import '@/scss/blocks/onetime-tooltip.scss';

export default {
    props: {
        show: {
            type: Boolean,
            _descr: 'Disabled to open tooltip',
        },
        submit: {},
    },
    components: {
        'align-opposite': require('@clearwave/odoro-markup/lib/vue/align-opposite.vue').default,
        'text-regular': require('@clearwave/odoro-markup/lib/vue/text-regular.vue').default,
    },
    data () {
        return {
            disabled: false,
        };
    },
    methods: {
        onBlur () {
            this.disabled = true;
        },
    },
    mounted () {
        if (this.$refs.onetimeTooltipContent) {
            this.$refs.onetimeTooltipContent.focus();
        }
    },
};
</script>
